import { User } from "../@core/data/users";

export default class Shop {
  id?: string;
  code?: string;
  title?: string;
  description?: string;
  tags?: string[];
  coverUrl?: string;
  status?: number;

  mobile?: string;
  address?: string;
  facebook?: string;
  instagram?: string;
  youtube?: string;
  website?: string;
  email?: string;
  tax?: string;

  product?: boolean;
  customer?: boolean;
  warehouse?: boolean;
  finance?: boolean;
  receipt?: boolean;
  purchase?: boolean;
  loan?: boolean;
  working?: boolean;
  trade?: boolean;
  receiptPurchase?: boolean;
  isPremium?: boolean;
  expDate?: Date;

  published?: boolean;
  publishedOn?: Date;
  privacy?: boolean;

  noProduct?: number;
  noUser?: number;
  noCustomer?: number;
  amount?: number;

  rating?: number;
  noRating?: number;
  noRating1?: number;
  noRating2?: number;
  noRating3?: number;
  noRating4?: number;
  noRating5?: number;

  noQnA?: number;
  noLiked?: number;
  noComment?: number;

  hearts?: number;

  isArchived?: boolean;
  shopIdArchived?: string;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
  companyId?: string;
}
